import {SET_CURRENT_PAGE} from "../types";

export default function EditBookForm(state = {}, action = {}) {
    switch (action.type) {
        case SET_CURRENT_PAGE:
            return action.data;
        default:
            return {currentPageNo: 1}
    }
}